import { BaseEdge, useInternalNode } from '@xyflow/react'
import React, { useMemo } from 'react'

import PropTypes from 'prop-types'
import { getEdgeParams, getHandleCoordsById } from '../../../Canvas/utils/getEdgeParams'
import { useEntityGraphContext } from '../../../Wrapper/EntityGraphProvider'
import { getEdgePath } from '../../../Canvas/utils/getEdgePath'

function LifeMapEdge ({ data: edgeData, labelStyle: _labelStyle, source, target, markerEnd, markerStart, targetHandleId, sourceHandleId, interactionWidth }) {
  const { state: { config, data } } = useEntityGraphContext()

  const lifeMapConfig = config?.lifeMap || {}

  const style = useMemo(() => edgeData?.style ?? undefined, [edgeData])

  const pathType = useMemo(() => config?.lifeMap.edgePathType ?? 'straight', [config?.lifeMap])
  const sourceNode = useInternalNode(source)
  const targetNode = useInternalNode(target)

  const { sx, sy, tx, ty, sourcePos, targetPos } = useMemo(() => getEdgeParams(
    sourceNode,
    targetNode
  ), [sourceNode, targetNode])

  const [targetHandleX, targetHandleY] = useMemo(() =>
    targetHandleId ? getHandleCoordsById(targetNode, targetHandleId) : [null, null],
  [targetNode, targetHandleId])

  const [sourceHandleX, sourceHandleY] = useMemo(() =>
    sourceHandleId ? getHandleCoordsById(sourceNode, sourceHandleId, 'source') : [null, null],
  [sourceNode, sourceHandleId])

  const [edgePath] = useMemo(() => getEdgePath({
    sourceX: sourceHandleX ?? sx,
    sourceY: sourceHandleY ?? sy,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    targetX: targetHandleX ?? tx,
    targetY: targetHandleY ?? ty
  }, pathType)
  , [sourceHandleX, sx, sourceHandleY, sy, sourcePos, targetPos, targetHandleX, tx, targetHandleY, ty, pathType])

  if (!sourceNode || !targetNode) {
    return null
  }

  if (lifeMapConfig.showEdgesOnlyWhenCompleted) {
    // eslint-disable-next-line no-unused-vars
    const targetNodeData = data?.nodes?.find(n => n.id === target)?.data || {}
    const isFilled = targetNodeData?.entityProps?.thingId

    if (!isFilled) return null
  }

  return (
    <>
      <BaseEdge
        path={edgePath}
        style={style}
      />
    </>
  )
}
LifeMapEdge.propTypes = {
  data: PropTypes.shape({
    style: PropTypes.object,
    label: PropTypes.string,
    labelStyle: PropTypes.object
  }),
  source: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  markerEnd: PropTypes.string,
  markerStart: PropTypes.string,
  targetHandleId: PropTypes.string,
  sourceHandleId: PropTypes.string,
  interactionWidth: PropTypes.number,
  labelStyle: PropTypes.object
}

export default LifeMapEdge
